import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next";
import { MDBAlert, MDBBreadcrumb, MDBBreadcrumbItem, MDBBtn, MDBCard, MDBCardBody, MDBCardText, MDBCardTitle, MDBDatatable, MDBIcon, MDBInput, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBSpinner, MDBTabs, MDBTabsContent, MDBTabsItem, MDBTabsLink, MDBTabsPane } from "mdb-react-ui-kit";
import { Tooltip } from "react-tooltip";
import MainLinks from "../components/navlinks/MainLinks";
import Body from "../components/body/BodyPage";
import { useLocation, useNavigate } from "react-router";
import TopSuccess from "../components/header/TopSuccess";
import TopMessage from "../components/header/TopMessage";
import { getSpecificPhoneRemediation } from "../apiclients/streamsapi_bridge";
import { formattedNumber } from "./popups/phonenumbers/AddRemoveNumbers";
import { customSearch, useAutoFocusSearchAfterLoads } from "../components/CustomSearchUtil/CustomSearch";
import UIConstant from "../apiclients/UIConstant";
function ReputationSettings() {
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [successMessage, setSuccessMessage] = useState("");
    const [isloading, setIsloading] = useState(false);
    const [internalError, setInternalError] = useState(false);
    const location = useLocation();
    const [phoneInfo, setphoneInfo] = useState([]);
    const navigate = useNavigate();
    const [imageUrl, setimageUrl] = useState("");
    const [flagService, setflagService] = useState([])
    const [pNumInfo, setPNumInfo] = useState(
        location.state ? location.state : {}
    );

    const [basicActive, setBasicActive] = useState('tab1');

    const [searchValue, setsearchValue] = useState("");
    const [filteredRows, setFilteredRows] = useState([]);
    const [rowdata, setRowData] = useState([]);  
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);
      useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef)
    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }

        setBasicActive(value);
    };

    useEffect(() => {
        if (pNumInfo.phone_number !== "") {
            getspecificRemedianInfo();
        }

    }, [pNumInfo]);

    const getspecificRemedianInfo = async () => {
        try {
            setIsloading(true);
            setInternalError(false);

            // Replace with your actual API call
            const response = await getSpecificPhoneRemediation(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid, pNumInfo.phone_number
            );
            setIsloading(false);
            const rawData = await response.json();

            if (response.status === 200) {
                setphoneInfo(rawData?.phNumberdetails ?? []);
            } else if (response.status === 500) {
                setInternalError(true);
            } else {
                navigate("/");
            }
        } catch (e) {
            console.log(`Unable to process the request: ${e}`);
            setInternalError(true);
        }
    }

    const [basicModal, setBasicModal] = useState(false);

    const toggleOpen = () => setBasicModal(!basicModal);

    const handleScreenShot = (screenshot, flaggedService) => {
        setimageUrl(screenshot);
        setflagService(flaggedService);
        toggleOpen();
    }
    
    useEffect(() => {
    let processdrows = [];
    phoneInfo.map((phnum) => {
        processdrows.push({
            phnumInfo: phnum,
            service: phnum?.flagged_service ? phnum.flagged_service + "" : "",
            screenshot: (
                    phnum?.screenshot && phnum.screenshot !== "" ? (
                        <div className="d-flex align-items-center ms-2">
                            <div
                                className="custom-hover-bg p-1 cursor-pointer screenshotToolTip"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    handleScreenShot(phnum?.screenshot ?? "", phnum?.flagged_service ?? "");
                                }}
                            >
                                <MDBIcon fas icon="image" color="primary" className="mx-1 fs-5" />
                            </div>
                        </div>
                    ) : ""
                ),
            violationDate: phnum.date ? phnum.date : "",
            alert: phnum?.alert ? phnum?.alert + "" : "",
        })
    });
    setRowData(processdrows)
    setFilteredRows(processdrows)
    setDataLoaded(true)
  },[phoneInfo])

    const tableData = {
        columns: [
            { label: 'Flagged Services', field: 'service' },
            { label: 'Screenshots', field: 'screenshot', sort: false },
            { label: 'Violation Date', field: 'violationDate' },
            { label: 'Alert', field: 'alert' },
        ],
        rows: rowdata,
    }


    const handleManualSearch = (searchValue) => {
        setsearchValue(searchValue);
        const filteredUsers = customSearch(rowdata, searchValue, UIConstant.REPUTATION_SETTINGS);
        setFilteredRows(filteredUsers);
    };
    return (
        <React.Fragment>
            <>
                <MainLinks active={2} />
                <Body
                    tablinks={2}
                    sublink={36}
                    content={
                        <>
                            <section className="mb-3">
                                <div className="card card-height">
                                    <div className="card-header py-3 px-0">
                                        <h5 className="mb-0 ">
                                            <MDBBreadcrumb>
                                                <MDBBreadcrumbItem>
                                                    <a onClick={() => window.location.href = "/phonenumbers"}>
                                                        <strong>{t("phoneSystem")}</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem active>
                                                    <a
                                                        onClick={() =>
                                                            navigate("/phonenumbers", { state: { tab: "tab5" } })
                                                        }
                                                    >
                                                        <strong>Reputation</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem>
                                                    <a>
                                                        <strong>{pNumInfo?.phone_number ? formattedNumber(pNumInfo?.phone_number) : ""}</strong>
                                                    </a>
                                                </MDBBreadcrumbItem>
                                            </MDBBreadcrumb>
                                        </h5>
                                    </div>
                                    <div className="card-body px-0">
                                        <div class="w-100 mb-3">
                                            <h5 class="fw-600 mt-2 mb-0">
                                                {pNumInfo?.phone_number ? formattedNumber(pNumInfo?.phone_number) : ""}
                                                {/* <p class="mt-1  text-secondary">
                                                    street 1,fie, street , abcdefgh, Alabama, 12345
                                                </p> */}
                                            </h5>
                                        </div>
                                        <MDBTabs className='mb-3'>
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                                                    History
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                        </MDBTabs>

                                        <MDBTabsContent>
                                            <MDBTabsPane open={basicActive === 'tab1'}>
                                                <div className="actionbar">
                                                    {/* <MDBBtn className="me-2" color="primary" onClick={() => console.log('Add Number')}>
                                                        <i className="fas fa-plus me-2"></i> Add Number
                                                    </MDBBtn> */}
                                                </div>
                                                <div className='mb-2 mt-2 position-relative w-auto'>
                                                    <MDBInput ref={searchRef} label="Search" value={searchValue} onChange={(e) => handleManualSearch(e.target.value)} />
                                                    <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                                                </div>
                                                <div className="whitelistDatatable">
                                                    <MDBDatatable key={searchValue}
                                                        className="FlaggedServicesDatatable"
                                                        hover
                                                        responsive
                                                        fixedHeader
                                                        data={{
                                                            ...tableData,
                                                            rows: filteredRows,
                                                          }}    
                                                    />
                                                </div>
                                            </MDBTabsPane>
                                        </MDBTabsContent>
                                    </div>
                                </div>
                            </section>


                        </>
                    }
                />
                <MDBModal open={basicModal} onClose={() => setBasicModal(false)} tabIndex='-1'>
                    <MDBModalDialog>
                        <MDBModalContent className="bg-transparent border-0 shadow-0">
                            <MDBModalBody className="p-0 bg-transparent border-0 shadow-0">
                                <img src={imageUrl} alt="No Image Found" className="view-screenshot" />
                            </MDBModalBody>

                        </MDBModalContent>
                    </MDBModalDialog>
                </MDBModal>
                <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                    Remove
                </Tooltip>
                <Tooltip anchorSelect=".screenshotToolTip" place="top" className="exampleTooltip">
                    View Screenshot
                </Tooltip>

                {internalError && (
                    <MDBAlert
                        open
                        className="alert-center"
                        color="danger"
                        autohide
                        position="bottom-right"
                        delay={5000}
                        onClose={() => setInternalError(false)}
                    >
                        Internal Server Error
                    </MDBAlert>

                )}
                {successMessage && (
                    <>
                        <TopSuccess>
                            <TopMessage successMessage={successMessage} />
                        </TopSuccess>
                    </>
                )}
                {isloading && (
                    <>
                        <div className="loadingclass">
                            <MDBBtn disabled>
                                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                Loading...
                            </MDBBtn>
                        </div>
                    </>
                )}
            </>
        </React.Fragment>
    )
}
export default ReputationSettings
